<template>
  <div class="areasTree">
    <Table
      stripe
      :columns="columns"
      :data="valueList"
      size="small"
      max-height="500"
    ></Table>
    <Button class="edit-btn" @click="drawerOpened = true" long>编辑</Button>
    <Drawer title="区域设置" v-model="drawerOpened">
      <Tree
        :data="treeData"
        :load-data="loadChildren"
        show-checkbox
        @on-check-change="onChange"
      ></Tree>
    </Drawer>
  </div>
</template>
<style lang="stylus" scoped>
.areasTree
  >>>.ivu-table-header
    height 40px

  >>>.ivu-table-header thead tr th
    padding 0

  .edit-btn
    margin-top 10px
</style>
<script>
export default {
  props: ['value', 'max'],
  data() {
    return {
      drawerOpened: false,
      columns: [
        { title: '省', key: 'province' },
        { title: '市', key: 'city' }
      ],
      valueList: [],
      treeData: [],
      valueModel: {},
      areasMap: ['provinceId', 'cityId', 'countyId']
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (!newValue) return
        this.valueList = []
        newValue.forEach(item => {
          let row = {
            province: item.province,
            city: item.city
          }
          this.valueList.push(row)
        })
      },
      deep: true,
      immediate: true
    },
    drawerOpened(newValue) {
      if (newValue) {
        this.resetCityNode(0)
      }
    }
  },
  created() {
    this.areasMap.forEach(item => {
      if (item in this.value[0]) {
        this.valueModel[item] = ''
      }
    })
    this.$store.state.provinces.forEach(item => {
      this.treeData.push({
        title: item.value,
        provinceId: item.key,
        loading: false,
        children: []
      })
    })
  },
  methods: {
    loadChildren(item, callback) {
      if (item.provinceId) {
        // 点击省
        this.$axios.get(`/region/${item.provinceId}/cities`).then(data => {
          let children = []
          data.forEach(_item => {
            let child = {
              title: _item.value,
              province: item.title,
              provinceId: item.provinceId,
              cityId: _item.key
            }
            if ('countyId' in this.valueModel) {
              child.loading = false
              child.children = []
            }
            children.push(child)
          })
          callback(children)
        })
      } else if (item.cityId) {
        // 点击第二级
        this.$axios
          .get(`/region/${item.__value.split(',')[1]}/countries`)
          .then(data => {
            data.forEach(_item => {
              item.children.push({
                label: _item.value,
                value: _item.key
              })
            })
            item.loading = false
            callback()
          })
      }
    },
    resetCityNode(i) {
      const valueListItem = this.valueList[i]
      let currentProvinceNode = this.treeData.find(
        node => node.title === valueListItem.province
      )
      if (currentProvinceNode.children.length === 0) {
        this.$axios
          .get(`/region/${currentProvinceNode.provinceId}/cities`)
          .then(data => {
            data.forEach(_item => {
              currentProvinceNode.children.push({
                title: _item.value,
                province: currentProvinceNode.title,
                provinceId: currentProvinceNode.provinceId,
                cityId: _item.key,
                checked: false
              })
            })
            let city = currentProvinceNode.children.find(
              cityNode => cityNode.title === valueListItem.city
            )
            city.checked = true
            if (i < this.valueList.length - 1) {
              this.resetCityNode(i + 1)
            }
          })
      } else {
        let city = currentProvinceNode.children.find(
          cityNode => cityNode.title === valueListItem.city
        )
        city.checked = true
        if (i < this.valueList.length - 1) {
          this.resetCityNode(i + 1)
        }
      }
    },
    onChange(checked) {
      // console.log(checked)
      let _value = []
      checked.forEach(item => {
        if (!item.cityId && item.children.length === 0) {
          // 未加载市节点
          this.$Message.warning(`请先展开「${item.title}」节点以初始化子选项`)
          item.checked = false
        }
        if (item.provinceId && item.cityId) {
          _value.push({
            province: item.province,
            provinceId: item.provinceId,
            city: item.title,
            cityId: item.cityId
          })
        }
      })
      this.$emit('input', _value)
    }
  }
}
</script>